import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import { withAccount } from '../../components/AccountContext';
import SurveyList from './SurveyList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../utils/UrlUtil';

export const LIST_QUERY = gql`
  query surveys(
    $accountId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: SurveyFilter
    $sort: SurveySortSpecifier
  ) {
    account(id: $accountId) {
      id
      surveys(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
        totalCount
        indexFrom
        indexTo
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            name
            createdOn
            statuses
            self {
              id
              respondent {
                id
                firstName
                lastName
                locale
              }
            }
            template {
              id
              title
            }
          }
        }
      }
    }
  }
`;

class SurveyListContainer extends Component {
  render() {
    const { currentAccount, location, translatedTags } = this.props;
    const params = parse(location.search);
    const pagination = filterPaginationWithSize(params);
    const variables = {
      ...pagination,
      accountId: currentAccount,
      sort: params.sort || { sortBy: 'createdOn', sortDir: 'DESC' },
      filter: params.filter,
    };
    return (
      <Query query={LIST_QUERY} variables={variables} fetchPolicy="network-only">
        {({ data, loading, error }) => {
          if (error) return `Error! ${error.message}`;

          const connection = data && data.account ? data.account.surveys : emptyConnection();

          return (
            <SurveyList
              connection={connection}
              currentAccount={currentAccount}
              translatedTags={translatedTags}
              loading={loading}
            />
          );
        }}
      </Query>
    );
  }
}

SurveyListContainer.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  translatedTags: PropTypes.arrayOf(PropTypes.any).isRequired,
};

const mapState = (state) => {
  const { translatedTags } = state.i18n;
  return {
    translatedTags,
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapState,
      null,
    )(withAccount(SurveyListContainer)),
  ),
);
